/* ========================================================================== *\
    Imports
/* ========================================================================== */
import { isElement, forEach, indexOf } from 'lodash';

import { publish, subscribe } from '../2-utilities/event';
import { queryAncestor } from '../2-utilities/dom';

import {
    START_AUTOPLAY as startAutoplay,
    STOP_AUTOPLAY as stopAutoplay,
    SIDEBAR_CLOSED,
    OPEN_SIDEBAR,
    ROW_CLICKED,
    SIDEBAR_OPENED
} from '../3-data/consts/eventNames';
import { isMobile } from '../2-utilities/breakpoint';

/* ========================================================================== *\
    Constants
/* ========================================================================== */
const moduleName = 'sidebar',
    baseSelector = `.js-${moduleName}`,
    classNames = {
        open: 'is-open'
    },
    selectors = {
        base: baseSelector,
        trigger: `${baseSelector}-trigger`
    };

/* ========================================================================== *\
    Functionality
/* ========================================================================== */

function toggleSidebar() {
    const element = document.querySelector(selectors.base);

    if (element.classList.contains(classNames.open)) {
        element.classList.remove(classNames.open);

        document.body.classList.remove('sidebar-is-open');

        publish(startAutoplay);
        publish(SIDEBAR_CLOSED)
    } else {
        element.classList.add(classNames.open);

        document.body.classList.add('sidebar-is-open');

        publish(stopAutoplay);
        publish(SIDEBAR_OPENED);
    }
}

function closeSidebar(e) {
    const element = document.querySelector(selectors.base);

    if (!element.classList.contains(classNames.open)) {
        return;
    }

    if (!queryAncestor(e.target, selectors.base)) {
        element.classList.remove(classNames.open);

        publish(startAutoplay);
        publish(SIDEBAR_CLOSED);
    }
}

function binding(element) {
    const trigger = element.querySelector(selectors.trigger);

    trigger.addEventListener('click', toggleSidebar);

    document.body.addEventListener('click', closeSidebar);
    subscribe(OPEN_SIDEBAR, toggleSidebar);
}

function init(baseElement = document.querySelector(selectors.base)) {
    if (!isElement(baseElement)) {
        return false;
    }

    setTimeout(() => {
        baseElement.classList.remove(classNames.open);
    }, 300);

    binding(baseElement);
}

init();
subscribe(ROW_CLICKED, () => {
    if (isMobile) {
        const element = document.querySelector(selectors.base);

        element.classList.remove(classNames.open);
    }
})